export default __webpack_public_path__ + "static/media/Icon-9.7052a502.png";